import styled from 'styled-components';
import { theme } from '@Themes/themeOverriderFabric';

const { lightGray } = theme.palette;

export const Container = styled.div(
    {
        height: 9,
        width: '100%',
        backgroundColor: lightGray,

        position: 'relative'
    },
    ({ round }) => {
        if (round) {
            return {
                borderRadius: 50,
                height: 8
            };
        }
    }
);

export const Bar = styled.div({
    height: '100%',
    width: props => `${props.width}%`,
    backgroundColor: props => props.backgroundColor,
    borderRadius: 'inherit',
    textAlign: 'right'
});

export const Dimmed = styled.div({
    position: 'absolute',
    width: ' 100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(241,234, 234 , 0.5)',
    zIndex: 1,
    borderRadius: 'inherit'
});
